/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-01-20 15:08:51
 *
 *******************************************************/

import _ from 'lodash';
import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import { Icon, Scrollable } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { CONSEQUENCE_TYPES } from 'src/constants/merchandising-v2';
import { connect } from 'react-redux';

type Props = {
  type: string,
  strategies: Array<Object>,
  ruleId: string
};

type ComposedProps = Props & WithI18nProps;

class StrategyType extends Component<ComposedProps> {
  render() {
    const {
      i18n,
      type,
      strategies = [],
      queries = [],
      isDisabledPerformanceRanking,
      ruleId,
      optionsList,
      isDisable
    } = this.props;
    const validStrategies = strategies.filter(
      item => item.type === 'pin' || !_.isEmpty(item.attributes)
    );

    const strategyWithType = _.filter(validStrategies, item => item.type === type);

    const hasType =
      !_.isEmpty(strategyWithType) ||
      // Enable product performance ranking => show icon
      (type === 'productPerformanceRanking' && !isDisabledPerformanceRanking);
    const consequenceType = CONSEQUENCE_TYPES[type];

    if (isDisable || !hasType) return null;
    if (isDisable)
      return (
        <span data-tip="dummy data" data-for={`${type}-${ruleId}`}>
          <Icon source={consequenceType.sourceIcon} color={'subdued'} />
        </span>
      );
    return (
      <>
        {/* Icon */}
        <span data-tip="dummy data" data-for={`${type}-${ruleId}`}>
          <Icon source={consequenceType.sourceIcon} color={hasType ? 'base' : 'subdued'} />
        </span>

        {/* Tooltip content */}
        {hasType && (
          <ReactTooltip
            id={`${type}-${ruleId}`}
            className="extraTooltipClass Polaris-Tooltip-TooltipOverlay Polaris-Tooltip-TooltipOverlay--positionedAbove"
            delayHide={0}
            effect="solid"
            type="light"
            getContent={function () {
              return (
                <Scrollable style={{ maxHeight: '400px' }} focusable>
                  <div className="Polaris-Tooltip-TooltipOverlay__Content">
                    {type === 'productPerformanceRanking'
                      ? consequenceType.renderTooltip(queries, i18n)
                      : consequenceType.renderTooltip(strategyWithType, i18n, optionsList)}
                  </div>
                </Scrollable>
              );
            }}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state, props) => {
  const optionsList = _.get(state.filterData.productAttributes, 'optionsList', []);

  return {
    optionsList
  };
};

export default withI18n()(connect(mapStateToProps)(StrategyType));
